import css from '../../../utils/css';

export default css`
  @font-face {
    font-display: swap;
    font-family: futura-pt-condensed;
    src:
      url(https://use.typekit.net/af/3b8138/00000000000000000001203f/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3)
        format('woff2'),
      url(https://use.typekit.net/af/3b8138/00000000000000000001203f/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3)
        format('woff'),
      url(https://use.typekit.net/af/3b8138/00000000000000000001203f/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3)
        format('opentype');
    font-style: normal;
    font-weight: 800;
  }

  :host {
    --color-1: white;
    --color-2: #20242e;
    --color-3: #1ed560;
    --color-4: #052643;

    /* Adapter */
    --widget-font-family: 'Public Sans', sans-serif;

    --widget-background-color: var(--color-1);
    --widget-text-color: var(--color-2);
    --widget-subtext-color: #9d9da3;
    --widget-border-color: #9dafbd;
    --widget-divider-color: #f2f2f2;
    --widget-header-bg-color: var(--color-4);
    --widget-header-text-color: var(--color-1);

    --widget-header-odds-bg-color: #eaeae9;
    --widget-mobile-seeall-color: var(--color-3);
    --widget-header-odds-shadow: #ccc;

    --widget-grid-best-odds-bg-color: var(--color-4);
    --widget-grid-best-odds-border-color: var(--color-4);
    --widget-grid-best-odds-text-color: var(--color-3);

    --widget-grid-compare-active-bg-color: var(--color-3);
    --widget-grid-compare-color: var(--color-4);

    --widget-grid-ribbon-bg-color: var(--color-3);
    --widget-grid-ribbon-color: var(--color-1);
  }
`;
